<script>
import { EventTag } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.tags)) {
        this.$set(this.form, 'tags', [])
      }
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.ForeignKey({
              label: 'Tagi wydarzeń',
              modelPath: [this, 'form', 'tags'],
              multiple: true,
              clearable: true,
              required: true,
              service: EventTag
            }),
            new fields.Input({
              label: 'Ilość wydarzeń na starcie (domyślnie 7)',
              modelPath: [this, 'form', 'show_on_start'],
              type: 'number'
            }),
            new fields.Input({
              label: 'Ilość doładowywanych wydarzeń (domyślnie 4)',
              modelPath: [this, 'form', 'next_open'],
              type: 'number'
            })
          ]
        }
      ]
    }
  }
}
</script>
